import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, Trophy, Flame, Star } from "lucide-react";
import { API, getAuthHeaders } from "@/App";

export default function GamificationDialog({ open, onOpenChange }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/gamification/me`, { headers: getAuthHeaders(), credentials: "include" });
      if (res.ok) setData(await res.json());
    } catch {}
    setLoading(false);
  };

  useEffect(() => { if (open) load(); }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#17212b] text-white border-[#0e1621] max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Trophy className="w-5 h-5 text-amber-400" /> Mi progreso</DialogTitle>
          <DialogDescription className="text-gray-400">Sube de nivel enviando mensajes, manteniendo tu racha y desbloqueando logros.</DialogDescription>
        </DialogHeader>
        {loading || !data ? (
          <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div>
        ) : (
          <div className="space-y-4">
            <div className="rounded-xl bg-gradient-to-br from-amber-500/20 to-amber-900/20 border border-amber-500/30 p-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-3xl font-bold text-amber-300 flex items-center gap-2"><Star className="w-7 h-7" /> Nivel {data.level}</div>
                  <div className="text-sm text-gray-300 mt-1">{data.xp} XP totales</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-300 flex items-center gap-1 justify-end"><Flame className="w-4 h-4 text-orange-400" /> {data.streak_days} días de racha</div>
                  <div className="text-xs text-gray-400 mt-1">{data.messages_sent} mensajes enviados</div>
                </div>
              </div>
              <div className="mt-3">
                <div className="h-2 bg-[#0e1621] rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-amber-400 to-amber-600 transition-all" style={{ width: `${Math.round((data.progress || 0) * 100)}%` }} />
                </div>
                <div className="text-xs text-gray-400 mt-1 text-right">{Math.max(0, data.next_level_xp - data.xp)} XP para nivel {data.level + 1}</div>
              </div>
            </div>
            <div>
              <div className="text-sm font-semibold mb-2">Logros</div>
              <div className="grid grid-cols-1 gap-2">
                {(data.achievements || []).map((a) => (
                  <div key={a.key} className={`flex items-center gap-3 p-3 rounded-lg border ${a.unlocked ? "border-amber-500/40 bg-amber-500/10" : "border-[#2b3a4a] bg-[#0e1621] opacity-60"}`}>
                    <div className="text-2xl shrink-0">{a.icon}</div>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium truncate">{a.name}</div>
                      <div className="text-xs text-gray-400 truncate">{a.description}</div>
                    </div>
                    <div className="text-xs font-semibold text-amber-300">+{a.xp} XP</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
